module.exports = __webpack_public_path__ + "91675277120adafcbf6a17d2a3faa059.svg";